import { Directive, ElementRef, HostListener, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: 'input:not([type="checkbox"]):not([type="radio"])',
})
export class TrimInputDirective {
  constructor(
    private element: ElementRef,
    @Optional() private control: NgControl,
  ) {}

  @HostListener('change') onChange() {
    const inputValue = this.element.nativeElement.value;
    if (inputValue && typeof inputValue === 'string') {
      const trimmedValue = inputValue.replace(/\s+/g, ' ').trim();
      this.element.nativeElement.value = trimmedValue;
      this.control.control?.setValue(trimmedValue, { emitEvent: false });
    }
  }
}
